import hubAPI from "../../hubAPI";

const ROOT_PATH = "api/v1/OneMobility";

/**
 *
 * @description This function is used to obtain the solution codes for a specific company and integrator solution, filtered by the logged-in ONE MOBILITY user.
 * @param {number} companyId
 * @param {number} integratorSolutionId
 * @returns {Promise}
 */
export const getSolutionsCodesOneMobility = async (companyId, integratorSolutionId) =>
  hubAPI.get(
    `${ROOT_PATH}/solutions/${companyId}/codes/${integratorSolutionId}`,
  );

